import React from 'react'

import PortfolioAccessQuickLink from "./access"
import ProjectCollectionInStructureModel
    from "../../../../../core/model2/project-collection/project-collection-in-structure-model"
import CustomersQuickLink from "../../../../../core/gd-app/component/quick-links/customers"
import UsersQuickLink from "../../../../../core/gd-app/component/quick-links/users"
// import Pin from "../../../../../core/gd-components/pin/pin"

type Props = {
    app: any
}

export default function PortfolioHeaderQuickControls(props: Props) {

    const projectCollection = gd.session.projectCollections.get(gd.projectCollectionViews.projectCollectionId)
    if (projectCollection?.isInStructure) {
        const pc = projectCollection as ProjectCollectionInStructureModel
        const project = gd.session.projects.get(pc.customViewModel.parentProjectId!)!
        return (
            <div className="quick-controls">
                <CustomersQuickLink project={project}/>
                <UsersQuickLink project={project}/>

                {/*<Pin data={{projectId: project.id}}/>*/}
            </div>
        )
    } else {
        return (
            <div className="quick-controls">
                <PortfolioAccessQuickLink app                   = {props.app}
                                          projectCollectionId   = {gd.projectCollectionViews.projectCollectionId}/>
                {/*<Pin data={{projectCollectionId: this.projectCollection.id}} className="" />*/}
            </div>
        )
    }
}